module.exports = __webpack_public_path__ + "fonts/Inter-600-latin63.30a274c.woff2";